import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import appPlatformDataAttributeDefResource from 'src/actions/externalapp/appPlatformDataAttributeDefResource';

export default function useAppPlatformDataAttributes(options = { fetch: true }) {
  const { value: dataAttributeDef } = useDocumentResource(appPlatformDataAttributeDefResource, {
    fetch: options.fetch,
  });
  return dataAttributeDef?.attributes || [];
}
